import { Outlet } from 'react-router-dom'
import { EventsListProvider } from './context/getEvents'
import ContainerEventos from './components/container'


export type Evento = {
  id: number,
  descricao: string,
  atividade: number,
  inicio: string,
  fim: string,
  nome_cidade: string,
  nome_sede: string,
  ministerio: string,
  sede: number,
  cidade: number,
  celula: number | string,
  inscricao: boolean,
  ativo: boolean,
  whatsapp: string,
  cep: string
}

export default function EventosPg() {

  return (
    <div style={{ display: "flex", flex: 1, padding: 5 }}>
      <EventsListProvider>
        <>
          <ContainerEventos />
          <Outlet />
        </>
      </EventsListProvider>
    </div>
  )
}
